import { createFileRoute } from '@tanstack/react-router';
import { assertPublicToolsEnabled } from '@/lib/public-tools-feature';
import { PdfToAudioDemoPage } from '@/components/astro/new-design-25/SEO/pdf-to-audio-demo-page';
import { pdfToAudioSearch } from '@/lib/pdf-to-audio-search';
import { hreflangLinks, seo } from '@/seo/seo';

const faqs = [
  {
    question: 'How do I convert a PDF to MP3?',
    answer:
      'Drop your PDF in the converter on this page. We generate natural audio and open a 24-hour Listening link with PDF view, synced audio, and playback controls.',
  },
  {
    question: 'What do I get after conversion?',
    answer:
      'You get a temporary read-along page that stays available for 24 hours. It includes the generated audio, PDF/text view, playbar, speed controls, and a copyable link.',
  },
  {
    question: 'Does the audio keep the same voice quality?',
    answer:
      'Yes. The generated audio uses the same natural AI voices as the in-browser read-along experience.',
  },
  {
    question: 'Any size limits?',
    answer:
      'The free preview is capped at 10 pages, 25,000 characters, and a 25 MB PDF. Sign up to convert full books and document libraries with no caps.',
  },
];

export const Route = createFileRoute('/_marketing/_seo/pdf-to-mp3')({
  validateSearch: pdfToAudioSearch,
  beforeLoad: assertPublicToolsEnabled,
  head: () => ({
    meta: [
      ...seo({
        title:
          'PDF to MP3 Online — Free PDF to MP3 Converter with AI Voices | Listening',
        description:
          'Convert PDF documents to audio online. Drop a PDF, pick a natural AI voice, and open a 24-hour read-along link you can play on any device. Free, no sign-up.',
      }),
    ],
    links: [...hreflangLinks('/pdf-to-mp3')],
  }),
  component: () => (
    <PdfToAudioDemoPage
      converterHeading='PDF to MP3'
      converterSubtitle='Drop a PDF, pick a natural AI voice, and open a 24-hour Listening link with PDF view, audio, and playback controls.'
      faqDescription='Quick answers about the free PDF to MP3 converter.'
      faqTitle='PDF to MP3 FAQ'
      faqs={faqs}
    />
  ),
});
